exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theia-tree-editor-form {\n  display: flex;\n}\n\n.theia-tree-editor-form > .jsonforms-container {\n  flex-grow: 1;\n  max-width: 960px; /* Half the width of a full hd display. */\n}\n", ""]);

// exports
